import { render, staticRenderFns } from "./login.vue?vue&type=template&id=fef9fe1c&scoped=true"
import script from "./login.vue?vue&type=script&lang=ts"
export * from "./login.vue?vue&type=script&lang=ts"
import style0 from "./login.vue?vue&type=style&index=0&id=fef9fe1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef9fe1c",
  null
  
)

export default component.exports